import ModalMuiTable from "../../../Components/Modals/ModalMuiTable.jsx";
import StockFilter from "../../../Components/Filters/StockFilter";

export const StockTableDetailed = ({ closeModal }) => {
  // const stockColumns = [
  //   { accessorKey: "REGION", header: "Region" },
  //   { accessorKey: "AREA", header: "Area" },
  //   { accessorKey: "STATE", header: "State" },
  //   { accessorKey: "DEALER_NAME", header: "Dealer Name" },
  //   { accessorKey: "DEALER_CODE", header: "Dealer Code" },
  //   { accessorKey: "Product_Line", header: "Product Line" },
  //   { accessorKey: "LOB", header: "LOB" },
  //   { accessorKey: "PPL", header: "PPL" },
  //   { accessorKey: "PL", header: "PL" },
  //   { accessorKey: "VC", header: "VC#" },
  //   { accessorKey: "chassis_no", header: "Chassis No" },
  //   { accessorKey: "STATUS", header: "Status" },
  //   { accessorKey: "STOCK_AGEING", header: "Stock Ageing" },
  // ];

  return (
    <div>
      <ModalMuiTable
        open={true}
        sliceName={"filtersStock"}
        FilterComponent={StockFilter}
        heading={"Stock Detailed Report"}
        apiEndpoint={"stocks/stocks-report"}
        onClose={closeModal}
      />
    </div>
  );
};

export default StockTableDetailed;
